/* eslint-disable no-console */
import React, { useRef, useState, useEffect, useCallback } from 'react';
import {
  AppShell,
  Navbar,
  Tabs,
  Paper,
  Group,
  Title,
  Aside,
  Image,
  Modal,
  Divider,
  Space,
  ActionIcon,
  Text,
  Stack,
  Input,
  Box,
  Center,
  MediaQuery,
  useMantineTheme,
  Button,
  ScrollArea,
  Loader,
} from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import { useFocusTrap } from '@mantine/hooks';
import Keyboard from 'react-simple-keyboard';
import OTPInput from 'otp-input-react';
import dayjs from 'dayjs';
import { CircleX, Edit, EditOff } from 'tabler-icons-react';
import 'react-simple-keyboard/build/css/index.css';
import LandingLayout from '../../components/LandingLayout';
import { sendRequest } from '../../services/services';
import PaymentStatus from '../PaymentStatus/PaymentStatus';
import PrintInvoice from '../PaymentStatus/invoice';
import Profile from '../Profile/profile';
import cashIcon from '../../image/cash.png';
import cardIcon from '../../image/card.png';

const Home = () => {
  const focusTrapRef = useFocusTrap();
  const theme = useMantineTheme();
  const [cardPay, setCardPay] = useState(false);
  const [payOpen, setPayOpen] = useState(false);
  const [cashOpened, setCashOpened] = useState(false);
  const [openInvoice, setOpenInvoice] = useState(false);
  // const [, setInput] = useState('');
  const [layout, setLayout] = useState('default');
  const keyboard = useRef(null);
  const [ticketNumber, setTicketNumber] = useState('');
  const [dummycharInput, setDummyCharInput] = useState('');
  const [shiftButtonText, setShiftButtonText] = useState('Arabic');
  const [ticketData, setTicketData] = useState();
  const [vehicleData, setVehicleData] = useState();
  const [, setCashData] = useState();
  const [response, setResponse] = useState({});
  const [paymentStatus, setPaymentStatus] = useState('');
  const [profileData, setProfileData] = useState('');
  const [inputData, setInputData] = useState('');
  const [, setTicketIdData] = useState();
  const [mobileData, setMobileData] = useState('');
  const [isMobileEdit, setIsMobileEdit] = useState(false);
  const [touched, setTouched] = useState(false);
  const [activeTab, setActiveTab] = useState('first');
  const [isLoading, setIsLoading] = useState(false); // Add isLoading state
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const comPortDetails = JSON.parse(localStorage.getItem('configDetails'));
  useEffect(() => {
    sendRequest(`cashier/profile`, 'get').then((res) => {
      setProfileData(res?.data || []);
    });
  }, []);

  const [socket, setSocket] = useState(null);

  useEffect(
    () =>
      // Clean up the WebSocket connection when the component unmounts
      () => {
        if (socket && socket.readyState === WebSocket.OPEN) {
          socket.close();
        }
      },
    [socket],
  );

  function sendSocketData(client) {
    // Connect to Wifi TCP IP port
    console.log('Connected With wifi TCP IP');
    const configIp =
      comPortDetails?.posIpAddress === undefined || null
        ? '192.168.2.0'
        : comPortDetails?.posIpAddress;
    const sendData = JSON.stringify({
      Event: 'CONNECTION',
      Operation: 'CONNECT',
      ConnectionMode: 'TCP',
      IpAddress: configIp,
      Port: 6100,
    });
    client.send(sendData);

    const amount = Number(ticketData?.result?.invoices?.payable_amount).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    const sendAmountData = JSON.stringify({
      Event: 'TRANSACTION',
      Operation: 'PURCHASE',
      Amount: amount,
      PrintSettings: '1',
      AppId: '11',
      ECRNumber: '1234567890123456',
    });
    client.send(sendAmountData);
  }

  function cardPayment() {
    setIsButtonDisabled(true);

    setTimeout(() => {
      setIsButtonDisabled(false);
    }, 30000);
    if (socket && socket.readyState === WebSocket.OPEN) {
      // If socket is already connected, do nothing
      return;
    }

    // Connect to the Geidea device through TCP/IP
    const newSocket = new WebSocket('ws://localhost:5000/messages');
    // Set up event listeners for WebSocket events

    newSocket.onopen = () => {
      console.log('Connected to Geidea device through TCP/IP');
      setSocket(newSocket);
      sendSocketData(newSocket);
    };

    newSocket.onmessage = (message) => {
      if (typeof message.data === 'string') {
        const geideaRes = JSON.parse(message?.data);
        console.log('geideaRes', geideaRes);
        if (geideaRes?.JsonResult) {
          setResponse(JSON.parse(message?.data));
        }
      }
      console.log('Received message from Geidea device:', message.data);
    };

    newSocket.onclose = () => {
      console.log('Disconnected from Geidea device');
      setSocket(null);
    };
  }

  console.log('response?.JsonResult', response);

  const paymentResponse = JSON.parse(response?.JsonResult || null);
  console.log('paymentStatus', paymentResponse?.Status);
  console.log('TransactionResponseEnglish', paymentResponse?.TransactionResponseEnglish);
  console.log('paymentStatus', paymentStatus);

  useEffect(() => {
    if (paymentResponse?.JsonResult?.TransactionResponseEnglish === 'APPROVED') {
      localStorage.setItem('payment', JSON.stringify(response?.JsonResult));
    }
  });

  const siteDetailsData = localStorage.getItem('payment');
  console.log('siteDetailsData', siteDetailsData);

  useEffect(() => {
    if (paymentResponse?.TerminalAction === 'SWIPE_OR_INSERT') {
      setCardPay(true);
    } else if (paymentResponse?.TerminalAction === 'IDLE_SCREEN') {
      setCardPay(false);
    } else if (paymentResponse?.TerminalAction === 'USER_CANCELLED_AND_TIMEOUT') {
      setCardPay(true);
      window.location.reload();
    } else if (paymentResponse?.EventName === 'TERMINAL_RESPONSE') {
      if (JSON.parse(response?.JsonResult)) {
        setPaymentStatus(JSON.parse(response?.JsonResult));
      }
    } else if (paymentResponse?.PaymentStatus === 'DECLINED') {
      setPaymentStatus();
    }
  }, [
    paymentResponse?.PaymentStatus,
    paymentResponse?.EventName,
    paymentResponse?.JsonResult,
    paymentResponse?.TerminalAction,
    paymentResponse?.Status,
  ]);

  const searchTicketNumberPlate = useCallback(() => {
    // Set isLoading to true before fetching data
    setIsLoading(true);
    sendRequest(`tickets/${dummycharInput}`, 'get')
      .then((res) => {
        if (res?.code === 20) {
          setVehicleData(res?.data || []);
          setTicketIdData(vehicleData?.pass_id);
        }
      })
      .catch((err) => {
        console.log('errr', err?.response?.data?.msg);
        if (err?.response?.data?.code) {
          showNotification({
            title: <Text weight={500}>{err?.response?.data?.msg}</Text>,
            icon: <CircleX size={16} />,
          });
        }
      })
      .finally(() => {
        setIsLoading(false); // Set isLoading to false after fetching data
      });
  }, [dummycharInput, vehicleData?.pass_id]);

  const urlEncodedPassId = inputData;
  const decodedPassId = decodeURIComponent(urlEncodedPassId);

  // Remove the Unicode control characters from the decoded pass ID
  const passId = decodedPassId.replace(/[^\d]/g, '');

  const searchTicket = useCallback(() => {
    setIsLoading(true);
    if (passId || vehicleData?.pass_id) {
      sendRequest(`cashier/reservations-by-pass-id/${passId || vehicleData?.pass_id}`, 'get')
        .then((res) => {
          if (res?.code === 20) {
            setTicketData(res?.data || []);
            setTicketIdData(passId);
          }
        })
        .catch((err) => {
          if (err?.response?.data?.code) {
            showNotification({
              title: <Text weight={500}>{err?.response?.data?.msg}</Text>,
              icon: <CircleX size={16} />,
            });
          }
        })
        .finally(() => {
          setIsLoading(false); // Set isLoading to false after fetching data
        });
    }
  }, [passId, vehicleData?.pass_id]);

  useEffect(() => {
    if (vehicleData?.pass_id) {
      setIsLoading(true);
      sendRequest(`cashier/reservations-by-pass-id/${vehicleData?.pass_id}`, 'get')
        .then((res) => {
          if (res?.code === 20) {
            setTicketData(res?.data || []);
            setTicketIdData(vehicleData?.pass_id);
          }
        })
        .catch((err) => {
          if (err?.response?.data?.code) {
            showNotification({
              title: <Text weight={500}>{err?.response?.data?.msg}</Text>,
              icon: <CircleX size={16} />,
            });
          }
        })
        .finally(() => {
          setIsLoading(false); // Set isLoading to false after fetching data
        });
    }
  }, [vehicleData, vehicleData?.pass_id]);

  const handleShift = () => {
    const newLayoutName = layout === 'default' ? 'shift' : 'default';
    setLayout(newLayoutName);
    if (shiftButtonText === 'Arabic') {
      setShiftButtonText('English');
    } else if (shiftButtonText === 'English') {
      setShiftButtonText('Arabic');
    }
  };

  const onKeyPress = (button) => {
    /**
     * If you want to handle the shift and caps lock buttons
     */
    if (button === '{shift}' || button === '{lock}') handleShift();
    if (button === '{enter}' && inputData !== '') {
      searchTicket();
    } else if (button === '{enter}' && dummycharInput !== '') {
      searchTicketNumberPlate();
    }
  };

  useEffect((button) => {
    if (button === '{enter}') {
      searchTicket();
      searchTicketNumberPlate();
    }
  });

  const onChangeNumber = (inputValue) => {
    setInputData(inputValue);
  };

  const onChangeMobileNumber = (inputValue) => {
    setMobileData(inputValue);
    console.log(inputValue);
    setTouched(true);
  };

  const onChangeInputNumber = (event) => {
    const data = event.target.value;
    setInputData(data);
    if (keyboard.current && typeof keyboard.current.setInputData === 'function') {
      keyboard.current.setInputData(data);
    }
  };

  const onChangeInputMobileNumber = (event) => {
    const data = event.target.value;
    setMobileData(data);
    keyboard.current.setMobileData(data);
    setTouched(true);
  };

  // const onInputChange = (e) => {
  //   setDummyInput(e);
  // };

  const onCharChange = (charInput) => {
    setDummyCharInput(charInput);
  };

  // const onCharChange = (e) => {
  //   setDummyCharInput(e);
  // };
  // const InputData = dummyInput + dummycharInput;

  // const onChange = () => {
  //   setInput(InputData);
  // };

  const now = dayjs();
  let date1;
  if (
    ticketData?.result?.tickets?.ticket_status_types?.id === 2 &&
    ticketData?.result?.tickets?.exit_time
  ) {
    date1 = dayjs(ticketData?.result?.tickets?.exit_time);
  } else if (!ticketData?.result?.tickets?.entry_time) {
    date1 = dayjs(ticketData?.result?.start_time);
  } else {
    date1 = dayjs(ticketData?.result?.tickets?.entry_time);
  }
  let date2;
  if (
    ticketData?.result?.tickets?.ticket_status_types?.id === 2 &&
    ticketData?.result?.tickets?.exit_time
  ) {
    date2 = dayjs(now);
  } else if (ticketData?.result?.tickets?.ticket_status_types?.id === 3) {
    date2 = dayjs(ticketData?.result?.tickets?.exit_time);
  } else if (ticketData?.result?.tickets?.ticket_status_types?.id === 2) {
    date2 = dayjs(now);
  } else if (!ticketData?.result?.exit_time) {
    date2 = dayjs(now);
  } else if (!ticketData?.result?.tickets?.exit_time) {
    date2 = dayjs(ticketData?.result?.end_time);
  } else {
    date2 = dayjs(ticketData?.result?.tickets?.exit_time);
  }

  const TotalSeconds = date2.diff(date1, 'minutes');
  let startDate;
  if (
    ticketData?.result?.tickets?.ticket_status_types?.id === 2 &&
    ticketData?.result?.tickets?.exit_time
  ) {
    startDate = dayjs(ticketData?.result?.tickets?.exit_time);
  } else if (!ticketData?.result?.tickets?.entry_time) {
    startDate = dayjs(ticketData?.result?.start_time);
  } else {
    startDate = dayjs(ticketData?.result?.tickets?.entry_time);
  }

  startDate = startDate.format('DD-MM-YYYY HH:mm').slice(0, -5);
  let startTime;
  if (
    ticketData?.result?.tickets?.ticket_status_types?.id === 2 &&
    ticketData?.result?.tickets?.exit_time
  ) {
    startTime = dayjs(ticketData?.result?.tickets?.exit_time);
  } else if (!ticketData?.result?.tickets?.entry_time) {
    startTime = dayjs(ticketData?.result?.start_time);
  } else {
    startTime = dayjs(ticketData?.result?.tickets?.entry_time);
  }

  startTime = startTime.format('DD-MM-YYYY HH:mm').slice(10);

  let endDate;
  if (
    ticketData?.result?.tickets?.ticket_status_types?.id === 2 &&
    ticketData?.result?.tickets?.exit_time
  ) {
    endDate = dayjs(now);
  } else if (ticketData?.result?.tickets?.ticket_status_types?.id === 3) {
    endDate = dayjs(ticketData?.result?.tickets?.exit_time);
  } else if (
    ticketData?.result?.tickets?.ticket_status_types?.id === 2 ||
    !ticketData?.result?.exit_time
  ) {
    endDate = dayjs(now);
  } else {
    endDate = dayjs(ticketData?.result?.end_time);
  }

  endDate = endDate.format('DD-MM-YYYY HH:mm').slice(0, -5);

  let endTime;
  if (
    ticketData?.result?.tickets?.ticket_status_types?.id === 2 &&
    ticketData?.result?.tickets?.exit_time
  ) {
    endTime = dayjs(now);
  } else if (ticketData?.result?.tickets?.ticket_status_types?.id === 3) {
    endTime = dayjs(ticketData?.result?.tickets?.exit_time);
  } else if (!ticketData?.result?.exit_time) {
    endTime = dayjs(now);
  } else {
    endTime = dayjs(ticketData?.result?.end_time);
  }

  endTime = endTime.format('DD-MM-YYYY HH:mm').slice(10);

  let mobileNumberValue;

  if (isMobileEdit) {
    mobileNumberValue = mobileData.toString();
  } else if (!ticketData?.result?.customers?.mobile) {
    mobileNumberValue = ticketData?.result?.guest_users?.mobile?.toString();
  } else {
    mobileNumberValue = ticketData?.result?.customers?.mobile?.toString();
  }

  console.log('mobileNumberValue', mobileNumberValue);
  const cashCollect = () => {
    const body = {
      reservation_id: parseInt(ticketData?.result?.id, 10),
      mobile: mobileNumberValue,
    };
    sendRequest(`cashier/cash-payment`, 'post', body)
      .then(({ data, code }) => {
        if (code === 20) {
          setCashData(data);
          setCashOpened(false);
          setPayOpen(true);
          searchTicket();
        }
      })
      .catch((err) => {
        if (err?.response?.data?.code) {
          showNotification({
            title: <Text weight={500}>{err?.response?.data?.msg}</Text>,
            icon: <CircleX size={16} />,
          });
        }
      });
  };

  const cardNameResult = paymentResponse?.CardAcceptorName;
  const CardName = cardNameResult ? cardNameResult.split('|')[2] : null;

  useEffect(() => {
    if (paymentResponse?.PaymentStatus === 'APPROVED') {
      const body = {
        reservation_id: parseInt(ticketData?.result?.id, 10),
        transaction_id: paymentResponse?.RetrievalReferenceNumber,
        card_name: CardName,
      };
      sendRequest(`cashier/card-payment`, 'post', body)
        .then(({ data, code }) => {
          if (code === 20) {
            setCashData(data);
            searchTicket();
            setPayOpen(true);
            searchTicket();
          }
        })
        .catch((err) => {
          if (err?.response?.data?.code) {
            showNotification({
              title: <Text weight={500}>{err?.response?.data?.msg}</Text>,
              icon: <CircleX size={16} />,
            });
          }
        });
    }
  }, [paymentResponse?.PaymentStatus]);

  const [barcodeRead, setBarcodeRead] = useState('');

  const barcode = {
    timing: 1000,
    data: '',
  };

  const barcodeReade = () => {
    if (barcode.data.length > 1) {
      setBarcodeRead(barcode.data);
    } else {
      barcode.data = '';
    }
  };

  let timeout = setTimeout(barcodeReade, 500);

  useEffect(() => {
    window.addEventListener('keypress', (e) => {
      if (barcode.data.length === 0 || e.timeStamp - barcode.timing < 1000) {
        barcode.data += e.key;
        barcode.timing = e.timeStamp;
        clearTimeout(timeout);
        timeout = setTimeout(barcodeReade, 500);
      } else {
        barcode.data = '';
      }
    });
  }, []);

  useEffect(() => {
    const urlValue = barcodeRead;

    const str = urlValue
      .trim()
      .split('/')
      .pop()
      .replace(/[^0-9]/g, '');
    setTicketNumber(str);
    setTicketNumber(str);
    console.log('ticketValue', str);
    if (ticketNumber > 0) {
      setIsLoading(true);
      sendRequest(`cashier/reservations-by-pass-id/${ticketNumber}`, 'get')
        .then((res) => {
          if (res?.code === 20) {
            setTicketData(res?.data || []);
          }
        })
        .catch((err) => {
          if (err?.response?.data?.code) {
            showNotification({
              title: <Text weight={500}>{err?.response?.data?.msg}</Text>,
              icon: <CircleX size={16} />,
            });
          }
        })
        .finally(() => {
          setIsLoading(false); // Set isLoading to false after fetching data
        });
    }
  }, [barcodeRead, ticketNumber]);

  const mobileEdit = () => {
    setIsMobileEdit(!isMobileEdit);
  };
  const showError = touched && (mobileData.length < 7 || mobileData.length > 12);

  useEffect(() => {
    if (activeTab === 'first') {
      if (keyboard.current) {
        keyboard.current.setInput('');
        setInputData('');
      }
    } else if (activeTab === 'second') {
      if (keyboard.current) {
        keyboard.current.setInput('');
        setDummyCharInput('');
      }
    }
  }, [activeTab]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  return (
    <LandingLayout
      className="no-printme"
      paymentStatus={ticketData?.result?.invoices?.invoice_status?.name}
      ticketId={ticketData?.id}
      totalSeconds={TotalSeconds}
    >
      <div>
        <AppShell
          style={{
            position: 'fixed',
            width: '1000px',
          }}
          styles={{
            main: {
              background:
                theme.colorScheme === 'dark' ? theme.colors.dark[8] : theme.colors.gray[0],
            },
          }}
          navbarOffsetBreakpoint="sm"
          asideOffsetBreakpoint="sm"
          navbar={
            <Navbar
              p="md"
              hiddenBreakpoint="sm"
              width={{ sm: 330, lg: 400 }}
              className="no-printme"
            >
              <Tabs value={activeTab} onTabChange={setActiveTab} color="gray" variant="pills">
                <Center style={{ backgroundColor: '#D9D9D9' }} py="xs">
                  <Tabs.List>
                    <Tabs.Tab value="first" onClick={() => handleTabChange('first')}>
                      <Title order={6}>Plate Number</Title>
                    </Tabs.Tab>
                    <Tabs.Tab value="second" onClick={() => handleTabChange('second')}>
                      <Title order={6}>Ticket Number</Title>
                    </Tabs.Tab>
                  </Tabs.List>
                </Center>

                <Tabs.Panel value="first">
                  <div style={{ backgroundColor: '#D9D9D9' }}>
                    <Center py="xs">
                      <Title order={3}>ENTER PLATE NUMBER</Title>
                    </Center>
                    <Group py="xs">
                      <Center p="xs">
                        <OTPInput
                          OTPLength={7}
                          inputStyles={{
                            width: '30px',
                            height: '30px',
                            fontSize: '1.3rem',
                            margin: '4px',
                          }}
                          value={dummycharInput}
                          disabled={ticketData?.id}
                        />
                      </Center>
                    </Group>
                  </div>
                  <Stack position="apart" py="xs">
                    <Box style={{ width: '300px' }}>
                      {isMobileEdit ? (
                        <Keyboard
                          keyboardRef={(r) => {
                            keyboard.current = r;
                          }}
                          onChange={onChangeMobileNumber}
                          layoutName={layout}
                          onKeyPress={onKeyPress}
                          maxLength={12}
                          theme="hg-theme-default hg-layout-default myTheme numbers-only"
                          layout={{
                            default: ['1 2 3', '4 5 6', '7 8 9', '0 {bksp}'],
                          }}
                          display={{
                            '{bksp}': '⌫',
                            '{enter}': 'Enter',
                          }}
                        />
                      ) : (
                        <Keyboard
                          keyboardRef={(r) => {
                            keyboard.current = r;
                          }}
                          onChange={onCharChange}
                          onKeyPress={onKeyPress}
                          layoutName={layout}
                          maxLength={7}
                          theme="hg-theme-default hg-layout-default myTheme enable-button"
                          layout={{
                            theme: 'hg-theme-default',
                            default: [
                              '1 2 3 4 5',
                              '6 7 8 9 0',
                              'A B J D R',
                              'S X T E V',
                              'G K L Z N',
                              'H U {bksp} {enter}',
                            ],
                          }}
                          display={{
                            '{bksp}': '←',
                            '{enter}': '✔',
                          }}
                        />
                      )}
                    </Box>
                  </Stack>
                </Tabs.Panel>
                <Tabs.Panel value="second">
                  <div style={{ margin: '0 0 8px 0px', backgroundColor: '#D9D9D9' }}>
                    <Center py="xs">
                      <Title order={3}>ENTER TICKET NUMBER</Title>
                    </Center>

                    <Input
                      value={inputData}
                      onChange={onChangeInputNumber}
                      ref={focusTrapRef}
                      py="xs"
                      p="sm"
                    />
                  </div>

                  <Box style={{ width: '300px' }}>
                    {isMobileEdit ? (
                      <Keyboard
                        keyboardRef={(r) => {
                          keyboard.current = r;
                        }}
                        onChange={onChangeMobileNumber}
                        layoutName={layout}
                        onKeyPress={onKeyPress}
                        maxLength={12}
                        theme="hg-theme-default hg-layout-default myTheme numbers-only"
                        layout={{
                          default: ['1 2 3', '4 5 6', '7 8 9', '0 {bksp}'],
                        }}
                        display={{
                          '{bksp}': '⌫',
                          '{enter}': 'Enter',
                        }}
                      />
                    ) : (
                      <Keyboard
                        keyboardRef={(r) => {
                          keyboard.current = r;
                        }}
                        onChange={onChangeNumber}
                        layoutName={layout}
                        onKeyPress={onKeyPress}
                        maxLength={19}
                        theme="hg-theme-default hg-layout-default myTheme numbers-only"
                        layout={{
                          theme: 'hg-theme-default',
                          default: ['1 2 3', '4 5 6', '7 8 9', '0 {bksp} {enter}'],
                        }}
                        display={{
                          '{bksp}': '←',
                          '{space}': ' ',
                          '{enter}': '✔',
                        }}
                      />
                    )}
                  </Box>
                  <Space h="xl" />
                </Tabs.Panel>
              </Tabs>
            </Navbar>
          }
          aside={
            <MediaQuery smallerThan="sm" styles={{ display: 'none' }} className="no-printme">
              <Aside p="md" hiddenBreakpoint="sm" width={{ sm: 220, lg: 240 }}>
                <Profile />
              </Aside>
            </MediaQuery>
          }
        >
          <Box style={{ width: '470px', margin: '-25px 0 0 -38px' }} className="no-printme">
            {ticketData?.result?.id ? (
              <Paper shadow="lg" withBorder p="xl">
                <Stack>
                  <Group position="apart" style={{ marginBottom: '-20px' }}>
                    <Group>
                      <Stack>
                        <Center>
                          <Title size="sm" order={2}>
                            Entry
                          </Title>
                        </Center>
                        <Center style={{ marginBottom: '-18px' }}>
                          <Text size="sm" weight={500}>
                            {startDate}
                          </Text>
                        </Center>
                        <Center>
                          <Text size="sm" weight={500}>
                            {startTime}
                          </Text>
                        </Center>
                      </Stack>
                    </Group>
                    <ActionIcon
                      color="dark"
                      size="xl"
                      radius="xl"
                      variant="default"
                      sx={{
                        borderColor: 'black',
                        width: '80px',
                        height: '80px',
                        borderRadius: '50px',
                      }}
                    >
                      <Text weight={900} size="lg">
                        {ticketData?.result?.invoices?.invoice_items[0]?.unit ?? 0} hrs
                      </Text>
                    </ActionIcon>
                    <Group>
                      <Stack>
                        <Center>
                          <Title size="sm" order={2}>
                            Exit
                          </Title>
                        </Center>
                        <Center style={{ marginBottom: '-18px' }}>
                          <Text size="sm" weight={500}>
                            {endDate}
                          </Text>
                        </Center>
                        <Center>
                          <Text size="sm" weight={500}>
                            {endTime}
                          </Text>
                        </Center>
                      </Stack>
                    </Group>
                  </Group>
                  <Space h="xs" />
                  <Group position="apart">
                    <Title size="sx" order={2}>
                      Description
                    </Title>
                    <Title size="sx" order={2}>
                      Unit Cost
                    </Title>
                    <Title size="sx" order={2}>
                      Quantity
                    </Title>
                    <Title size="sx" order={2}>
                      Amount
                    </Title>
                  </Group>
                  <ScrollArea style={{ height: 90 }} offsetScrollbars scrollbarSize={2}>
                    <Group position="apart" style={{ marginBottom: 0.5, marginTop: 0.5 }}>
                      {ticketData?.result?.reservation_types === null ? null : (
                        <Text size="sm" weight={500} color="#817E7E" style={{ width: '65px' }}>
                          {ticketData?.result?.invoices?.invoice_items[0]?.unit ?? 0} hours parking
                        </Text>
                      )}
                      {ticketData?.result?.reservation_types === null ? null : (
                        <Text size="sm" weight={500} color="#817E7E">
                          {Number(
                            ticketData?.result?.invoices?.invoice_items[0]?.unit_price ?? 0,
                          ).toLocaleString('en-US', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </Text>
                      )}
                      {ticketData?.result?.reservation_types === null ? null : (
                        <Text size="sm" weight={500} color="#817E7E">
                          {ticketData?.result?.invoices?.invoice_items[0]?.unit ?? 0}
                        </Text>
                      )}
                      {ticketData?.result?.reservation_types === null ? null : (
                        <Text size="sm" weight={500} color="#817E7E">
                          {Number(
                            ticketData?.result?.invoices?.invoice_items[0]?.amount ?? 0,
                          ).toLocaleString('en-US', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                          SAR
                        </Text>
                      )}
                    </Group>
                    <Space h="xl" />
                    <Group position="apart" style={{ marginBottom: 0.5, marginTop: 0.5 }}>
                      <Stack spacing="xl">
                        {ticketData?.result?.vas_orders.map((item) => (
                          <Text size="sm" weight={500} color="#817E7E" style={{ width: '65px' }}>
                            {item?.vas_types?.name}
                          </Text>
                        ))}
                      </Stack>

                      <Stack spacing="xl">
                        {ticketData?.result?.vas_orders.map((item) => (
                          <Text size="sm" weight={500} color="#817E7E">
                            {Number(item?.amount ?? 0).toLocaleString('en-US', {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </Text>
                        ))}
                      </Stack>

                      <Stack spacing="xl">
                        {ticketData?.result?.vas_orders.map((item) => (
                          <Text size="sm" weight={500} color="#817E7E">
                            {item?.qty}
                          </Text>
                        ))}
                      </Stack>

                      <Stack spacing="xl">
                        {ticketData?.result?.vas_orders.map((item) => {
                          const amount = item?.amount ?? 0;
                          const qty = item?.qty ?? 0;
                          const total = amount * qty ?? 0;

                          return (
                            <Text size="sm" weight={500} color="#817E7E">
                              {total.toLocaleString('en-US', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}{' '}
                              SAR
                            </Text>
                          );
                        })}
                      </Stack>
                    </Group>
                    <Group position="apart" grow style={{ marginBottom: 0.5, marginTop: 0.5 }}>
                      <Stack>
                        {ticketData?.result?.enforcements.map((em) => (
                          <Text size="sm" weight={500} color="#817E7E">
                            {em?.name}
                          </Text>
                        ))}
                      </Stack>

                      <Stack>
                        {ticketData?.result?.enforcements.map((em) => (
                          <Text size="sm" weight={500} color="#817E7E">
                            {Number(em?.amount ?? 0).toLocaleString('en-US', {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </Text>
                        ))}
                      </Stack>

                      <Stack>
                        {ticketData?.result?.enforcements.map((em) => (
                          <Text size="sm" weight={500} color="#817E7E">
                            {em ? 1 : 0}
                          </Text>
                        ))}
                      </Stack>

                      <Stack>
                        {ticketData?.result?.enforcements.map((em) => (
                          <Text size="sm" weight={500} color="#817E7E">
                            {Number(em?.amount ?? 0).toLocaleString('en-US', {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                            SAR
                          </Text>
                        ))}
                      </Stack>
                    </Group>
                  </ScrollArea>
                  <Divider my="sm" />

                  <Group position="apart">
                    <Text size="sm" weight={500} color="#817E7E">
                      Sub total
                    </Text>
                    <Space w="xl" />
                    <Text size="sm" weight={500} color="#817E7E">
                      {Number(ticketData?.result?.invoices?.total_amount ?? 0).toLocaleString(
                        'en-US',
                        { minimumFractionDigits: 2, maximumFractionDigits: 2 },
                      )}
                      SAR
                    </Text>
                  </Group>

                  <Group position="apart">
                    <Text size="sm" weight={500} color="#817E7E">
                      Tax ( 15% )
                    </Text>
                    <Space w="xl" />
                    <Text size="sm" weight={500} color="#817E7E">
                      {ticketData?.result?.invoices?.total_amount &&
                        `${(Number(ticketData.result.invoices.total_amount) * 0.15).toLocaleString(
                          'en-US',
                          { minimumFractionDigits: 2, maximumFractionDigits: 2 },
                        )} SAR`}
                    </Text>
                  </Group>

                  {ticketData?.result?.invoices?.paid_amount > 0 ? (
                    <Group position="apart">
                      <Text size="sm" weight={500} color="#817E7E">
                        Paid Amount
                      </Text>
                      <Space w="xl" />
                      <Text size="sm" weight={500} color="#817E7E">
                        {Number(ticketData?.result?.invoices?.paid_amount).toLocaleString('en-US', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}{' '}
                        SAR
                      </Text>
                    </Group>
                  ) : null}
                </Stack>
                <Space h="xs" />

                <Divider size="sm" />
                <Group position="apart" style={{ marginBottom: 5, marginTop: 5 }}>
                  <Title size="sm" order={1}>
                    Total
                  </Title>
                  <Title size="sm" order={1}>
                    {ticketData?.result?.invoices?.payable_amount.toLocaleString('en-US', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </Title>
                  <Title size="sm" order={1}>
                    SAR
                  </Title>
                </Group>
                <Divider size="sm" />

                <Stack>
                  <Title order={5}>Customer Info</Title>
                  <Group>
                    {ticketData?.result?.guest_users === null ? (
                      <Title order={5}>
                        Name:{' '}
                        {!ticketData?.result?.customers?.full_name
                          ? 'Guest'
                          : ticketData?.result?.customers?.full_name}
                      </Title>
                    ) : (
                      <Title order={5}>
                        Name:{' '}
                        {!ticketData?.result?.guest_users?.first_name
                          ? 'Guest'
                          : ticketData?.result?.guest_users?.first_name}
                      </Title>
                    )}
                    <Group>
                      <Input.Label>Mobile:</Input.Label>
                      {!isMobileEdit ? (
                        <div>
                          {ticketData?.result?.guest_users === null ? (
                            <Group>
                              <Title order={5}>
                                {!ticketData?.result?.customers?.country_code?.dial_code
                                  ? '---'
                                  : ticketData?.result?.customers?.country_code?.dial_code}
                              </Title>
                              <Title order={5}>
                                {!ticketData?.result?.customers?.mobile
                                  ? '---'
                                  : ticketData?.result?.customers?.mobile}
                              </Title>
                            </Group>
                          ) : (
                            <Group>
                              <Title order={5}>
                                {!ticketData?.result?.guest_users?.country_code?.dial_code
                                  ? '---'
                                  : ticketData?.result?.guest_users?.country_code?.dial_code}
                              </Title>
                              <Title order={5}>
                                {!ticketData?.result?.guest_users?.mobile
                                  ? '---'
                                  : ticketData?.result?.guest_users?.mobile}
                              </Title>
                            </Group>
                          )}
                        </div>
                      ) : (
                        <Input.Wrapper>
                          <Input
                            style={{ width: '150px' }}
                            minLength={7}
                            value={mobileData}
                            onChange={onChangeInputMobileNumber}
                            ref={focusTrapRef}
                          />
                          {showError && (
                            <Text fz="xs" color="red">
                              Mobile Number min 7 and max 12
                            </Text>
                          )}
                        </Input.Wrapper>
                      )}

                      <ActionIcon>
                        {!isMobileEdit ? (
                          <Edit size={48} strokeWidth={2} color="black" onClick={mobileEdit} />
                        ) : (
                          <EditOff size={48} onClick={mobileEdit} strokeWidth={2} color="black" />
                        )}
                      </ActionIcon>
                    </Group>
                  </Group>
                  {ticketData?.result?.tickets?.ticket_status_types?.id === 4 ? (
                    <Center>
                      <Title order={5} style={{ color: 'red' }}>
                        Invalid Ticket
                      </Title>
                    </Center>
                  ) : (
                    <Group>
                      <Title order={5}>payment Info : </Title>
                      {ticketData?.result?.invoices?.invoice_status?.name === 'paid' ? (
                        <Title order={5}> Paid </Title>
                      ) : (
                        <Title order={5}> Pending </Title>
                      )}
                    </Group>
                  )}

                  {ticketData?.result?.invoices?.invoice_status?.name === 'paid' ? (
                    <Center>
                      <Button
                        style={{ width: '45%', backgroundColor: '#01AA84' }}
                        onClick={() => setOpenInvoice(true)}
                      >
                        Print Invoice
                      </Button>
                    </Center>
                  ) : (
                    <Group px="xl">
                      <Button
                        leftIcon={<Image src={cardIcon} size={14} />}
                        style={{ width: '45%', backgroundColor: '#01AA84' }}
                        onClick={() => cardPayment()}
                        disabled={
                          ticketData?.result?.invoices?.invoice_status?.name === 'paid' ||
                          ticketData?.result?.reservation_types === null
                            ? null
                            : TotalSeconds <= comPortDetails?.gracePeriod ||
                              isButtonDisabled ||
                              ticketData?.result?.tickets?.ticket_status_types?.id === 4
                        }
                      >
                        Card
                      </Button>
                      <Button
                        leftIcon={<Image src={cashIcon} size={14} />}
                        style={{ width: '45%', backgroundColor: '#01AA84' }}
                        onClick={() => setCashOpened(true)}
                        disabled={
                          ticketData?.result?.reservation_types === null
                            ? null
                            : TotalSeconds <= comPortDetails?.gracePeriod ||
                              ticketData?.result?.tickets?.ticket_status_types?.id === 4
                        }
                      >
                        {ticketData?.result?.invoices?.invoice_status?.name === 'paid'
                          ? 'Print Invoice'
                          : 'Cash'}
                      </Button>
                    </Group>
                  )}
                </Stack>
              </Paper>
            ) : (
              <Box>
                {isLoading ? ( // Display loading state if isLoading is true
                  <Center>
                    <Stack>
                      <Center>
                        <Loader />
                      </Center>
                      <Center>
                        <Title>Loading...</Title>
                      </Center>
                    </Stack>
                  </Center>
                ) : (
                  <Stack>
                    <Center>
                      <Title>Waiting for Details...</Title>
                    </Center>
                    <Center>
                      <Title>search by</Title>
                    </Center>
                    <Center>
                      <Title>NumberPlate</Title>
                    </Center>
                    <Center>
                      <Title>/</Title>
                    </Center>
                    <Center>
                      <Title>Ticket Number</Title>
                    </Center>
                  </Stack>
                )}
              </Box>
            )}
          </Box>

          <Modal
            opened={cardPay}
            onClose={() => {
              window.location.reload();
              setCardPay(false);
            }}
            centered
          >
            <Center>
              {paymentResponse?.TerminalAction === 'SWIPE_OR_INSERT' ? (
                <Stack>
                  <Title order={1}>Swipe or Insert</Title>
                  <Center>
                    <Title order={1}>Card</Title>
                  </Center>
                </Stack>
              ) : (
                <div>
                  {paymentResponse?.TerminalAction === 'USER_CANCELLED_AND_TIMEOUT' ? (
                    <Stack>
                      <Title order={1}>Cancel or Timeout</Title>
                    </Stack>
                  ) : (
                    <div>
                      {(() => {
                        if (
                          paymentResponse?.PaymentStatus === 'APPROVED' &&
                          ticketData?.result?.invoices?.invoice_status?.name === 'paid'
                        ) {
                          return (
                            <PaymentStatus
                              passDataId={ticketData?.result?.pass_id}
                              profile={profileData}
                            />
                          );
                        }

                        if (paymentResponse?.PaymentStatus === 'DECLINED') {
                          return (
                            <Stack>
                              <Title order={1}>Card Declined</Title>
                            </Stack>
                          );
                        }

                        if (paymentResponse?.TerminalAction === 'SENDING_REQUEST') {
                          return (
                            <Stack>
                              <Title order={1}>Processing...</Title>
                            </Stack>
                          );
                        }

                        return (
                          <Stack>
                            <Title order={1}>{paymentResponse?.TerminalAction}</Title>
                          </Stack>
                        );
                      })()}
                    </div>
                  )}
                </div>
              )}
            </Center>
          </Modal>

          <Modal opened={cashOpened} onClose={() => setCashOpened(false)} centered>
            <Center>
              {ticketData?.result?.invoices?.invoice_status?.name === 'paid' ? null : (
                <Title order={1}>
                  Amount :{' '}
                  {ticketData?.result?.invoices?.payable_amount.toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}{' '}
                  SAR
                </Title>
              )}
            </Center>
            <Center py="xl">
              {ticketData?.result?.invoices?.invoice_status?.name === 'paid' ? (
                <PaymentStatus passDataId={ticketData?.result?.pass_id} profile={profileData} />
              ) : (
                <Button style={{ width: '40%', backgroundColor: '#01AA84' }} onClick={cashCollect}>
                  <Text>Collect</Text>
                </Button>
              )}
            </Center>
          </Modal>
          <Modal
            opened={payOpen}
            onClose={() => {
              window.location.reload(); // Reload the page
              setOpenInvoice(false); // Close the Modal
            }}
            centered
            withCloseButton
          >
            <Center py="xl">
              <PaymentStatus passDataId={ticketData?.result?.pass_id} profile={profileData} />
            </Center>
          </Modal>
          <Modal
            opened={openInvoice}
            onClose={() => {
              window.location.reload(); // Reload the page
              setOpenInvoice(false); // Close the Modal
            }}
            withCloseButton
            centered
          >
            <PrintInvoice passDataId={ticketData?.result?.pass_id} profile={profileData} />
          </Modal>
        </AppShell>
      </div>
    </LandingLayout>
  );
};

export default Home;
